var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hello"},[_c('h4',[_vm._v("Sistema de Audiencias")]),_c('p'),_c('img',{staticClass:"img-fluid",attrs:{"src":require("../assets/inicio.jpg")}})])
}]

export { render, staticRenderFns }